module.exports = require("@aws-sdk/s3-request-presigner");